module.exports = __webpack_public_path__ + "img/img18.a52cce96.png";